import { Button, ButtonProps, ButtonLink } from '../button/button';
import { F0 } from '@client/new/helpers/types';
import { IndexLinkProps, LinkProps } from 'react-router';

export type CtaProps = {
  caption: string;
  onClick?: F0;
  disabled?: boolean;
  state?: 'disabled';
  className?: string;
  secondary?: boolean;
  testId?: string;
} & Partial<Pick<IndexLinkProps, 'to'>>;

export const Cta = (p: CtaProps) => {
  const buttonProps: Partial<ButtonProps> = {
    onClick: p.onClick,
    disabled: p.state === 'disabled',
    color: 'neutral',
    variant: p.secondary ? 'text' : 'filled',
    className: p.className,
    testId: p.testId,
  };

  const to = p.to || '';
  const linkProps = to.toString().startsWith('http')
    ? ({ href: to, to: '', target: '_blank' } as Pick<
        LinkProps,
        'to' | 'href' | 'target'
      >)
    : ({ to } as Pick<IndexLinkProps, 'to'>);

  return p.onClick && !to ? (
    <Button {...buttonProps}>{p.caption}</Button>
  ) : (
    <ButtonLink {...buttonProps} {...linkProps}>
      {p.caption}
    </ButtonLink>
  );
};
